import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as userMonitorEventActions from "./userMonitorEventActions";
import * as userMonitorEventSelectors from "./userMonitorEventSelectors";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, mergeMap } from "rxjs/operators";
import { of } from "rxjs";

export const userEpic: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    ofType(userMonitorEventActions.GET_USER_MONITOR_EVENT_LIST),
    exhaustMap(
      (action: userMonitorEventActions.GetUserMonitorEventListAction) => {
        const state = state$.value;

        let nextPageUrl: string | undefined;
        if (
          action.subtype ===
          userMonitorEventActions.GetUserMonitorSubtype.LoadNextPage
        ) {
          nextPageUrl = userMonitorEventSelectors.nextPageUrl(
            state,
            action.organization,
            action.filters
          );
        }

        return services.apiMonitorEvent
          .list(
            authSelectors.accessToken(state),
            authSelectors.selectedOrganizationKeyName(state),
            action.filters,
            nextPageUrl
          )
          .pipe(
            mergeMap((response) =>
              of(
                userMonitorEventActions.getUserMonitorEventListSuccessAction(
                  action.organization,
                  response,
                  action.filters
                )
              )
            ),
            catchError(() => {
              services.toastr.error(
                "Fail",
                "There was error while fetching user monitor events"
              );
              return of(
                userMonitorEventActions.getUserMonitorEventListFailAction(
                  action.organization,
                  action.filters
                )
              );
            })
          );
      }
    )
  );
